import { MediaQueries } from 'custom_hooks/useWindowSize';
import { DashboardPageLayout } from 'pages/Dashboard/components/styled';
import styled from 'styled-components';

export {
    Card,
    CardContent,
    CardTitle,
    Header,
    HeaderControls,
} from 'pages/Dashboard/components/styled';

export const Page = styled(DashboardPageLayout)`
    display: grid;
    grid-template-areas:
        'head head head'
        'counts deploy-scope   value-by-type'
        'counts asset-coverage value-over-time';
    grid-template-rows: 8rem minmax(30vh, 1fr) 1fr;
    grid-template-columns: 28rem 1fr 1fr;

    .head {
        grid-area: head;
        align-content: center;
        & > h1 {
            font-size: 2.4rem;
        }
    }

    .counts {
        grid-area: counts;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        min-height: 40rem;
    }

    .deploy-scope {
        grid-area: deploy-scope;
    }

    .value-by-type {
        grid-area: value-by-type;
    }

    .asset-coverage {
        grid-area: asset-coverage;
    }

    .value-over-time {
        grid-area: value-over-time;
    }

    @media ${MediaQueries.largeAndDown} {
        grid-template-areas:
            'head'
            'counts'
            'deploy-scope'
            'value-by-type'
            'asset-coverage'
            'value-over-time';
        grid-template-columns: 1fr;
        grid-template-rows: auto;

        .counts {
            min-height: 22rem;
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            grid-template-rows: auto;
            justify-content: center;
            align-content: center;
            & > * {
                height: fit-content;
            }
        }

        .deploy-scope {
            min-height: 40rem;
        }

        .value-by-type {
            min-height: 40rem;
        }

        .asset-coverage {
            min-height: 40rem;
        }

        .value-over-time {
            min-height: 40rem;
        }
    }
`;
